<template>
  <v-app-bar
    id="toolbar"
    v-long-press="statusBarPressed"
    color="primary"
    extension-height="18"
    extension-color="danger"
    class="toolbar"
    dark
    fixed
    dense
    app
  >
    <v-icon
      v-show="showmenu"
      name="main-menu"
      class="mr-3"
      @click="setDrawer"
    >
      mdi-menu
    </v-icon>
    <v-toolbar-title
      @click="showUserName"
    >
      <span
        id="toolbar-title"
      >
        {{ userName !== null && userName !== '' ? userName : title }}
      </span>
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items
      v-if="!IS_DESKTOP"
      @click="displayPercent"
    >
      <v-icon
        v-show="totalTransactions > 0"
        class="px-1"
        color="#FFA600AA"
      >
        mdi-cloud-sync
      </v-icon>
      <div
        v-show="showTransactions"
        class="transactions-tooltip"
      >
        <div class="subheading mb-2">
          {{ $t('field.trx_in_wait', { nb: totalTransactions }) }}
        </div>
        <div v-show="transactions.pax > 0">
          {{ $t('field.trx_bank') }} {{ transactions.pax }}
        </div>
        <div v-show="transactions.cashless > 0">
          {{ $t('field.trx_cashless') }} {{ transactions.cashless }}
        </div>
        <div v-show="transactions.donation > 0">
          {{ $t('field.trx_donation') }} {{ transactions.donation }}
        </div>
        <div v-show="transactions.tips > 0">
          {{ $t('field.trx_tips') }} {{ transactions.tips }}
        </div>
        <v-btn
          :disabled="!isConnected"
          @click="sendTransactions"
        >
          {{ $t('field.send_trx') }}
        </v-btn>
      </div>
      <v-icon
        v-show="useBattery"
        :color="batteryColor"
        class="px-1"
      >
        {{ `mdi-battery${batteryStatus}` }}
      </v-icon>
      <span
        v-show="showPercent"
        class="mt-3"
      >
        {{ batteryLevel }}%
      </span>
      <v-icon>{{ networkStatus }}</v-icon>
    </v-toolbar-items>

    <env-dialog
      v-model="showEnv"
      @change-env="changeEnv"
    />

    <template
      v-if="currentEnv !== 0"
      v-slot:extension
    >
      <span class="caption bloc text-center">
        {{ $t('field.demo') }} ({{ $t(currentEnv === 1 ? 'enums.env.int' : 'enums.env.dev') }})
      </span>
    </template>
  </v-app-bar>
</template>

<script>
import {IconEnum} from '@/modules/Enums'
import { $getNumberOfTransactions } from '@/modules/Transactions'

import EnvDialog from '../modal/EnvDialog'

export default {
  name: 'Toolbar',

  components: {
    EnvDialog
  },

  props: {
    title: { type: String, required: true },
    cashierName: { type: String, default: null },
  },

  data () {
    return {
      IS_DESKTOP,
      //
      batteryLevel: 0,
      isPlugged: false,
      showPercent: false,
      //
      brightnessLow: false,
      brightnessTimeout: null,
      //
      userName: null,
      showEnv: false,
      currentEnv: 0,
      //
      paxTimeout: null,
      paxTimeoutDuration: 5 * 60000,
      showTransactions: false
    }
  },

  computed: {
    showmenu() {
      return this.$route.name === 'home' || this.$route.name === 'index'
    },
    usebrightness() {
      return this.$store.state.usebrightness
    },
    keepscreenon() {
      return this.$store.state.keepscreenon
    },
    duration() {
      return this.$store.state.duration
    },
    useBattery() {
      return this.batteryLevel > 0
    },
    usevibrate() {
      return this.$store.state.usevibrate
    },
    batteryStatus() {
      if (this.isPlugged) {
        return '-charging'
      } else if (this.batteryLevel <= 10) {
        return '-alert'
      } else if (this.batteryLevel <= 90) {
        return '-' + (10 * Math.floor(this.batteryLevel / 10))
      } else {
        return ''
      }
    },
    batteryColor() {
      if (this.batteryLevel <= 10) {
        return '#D9032C'
      } else if (this.batteryLevel <= 25) {
        return '#B32A00'
      } else if (this.batteryLevel <= 50) {
        return '#FFA600'
      } else {
        return '#49D061'
      }
    },
    networkType: {
      get() {
        return this.$store.state.networkType
      },
      set(val) {
        this.$store.commit('networkType', val)
      }
    },
    networkStatus() {
      switch (this.networkType) {
        default:
        case Connection.NONE:
        case Connection.UNKNOWN:
          return IconEnum.wifi_off
        case Connection.WIFI:
          return IconEnum.wifi
        case Connection.ETHERNET:
          return IconEnum.wan
        case Connection.CELL:
        case Connection.CELL_2G:
          return IconEnum.g_2
        case Connection.CELL_3G:
          return IconEnum.g_3
        case Connection.CELL_4G:
          return IconEnum.g_4
      }
    },
    isConnected() {
      return this.$store.getters.isConnected
    },
    transactions() {
      return this.$store.state.transactions
    },
    totalTransactions() {
      return this.$store.getters.totalTransactions
    }
  },
  beforeMount () {
    if (!IS_DESKTOP) {
      window.addEventListener('online', this.onConnectionChange, false)
      window.addEventListener('offline', this.onConnectionChange, false)

      window.addEventListener('batterystatus', this.onBatteryStatus, false)
      window.addEventListener('batterylow', this.onBatteryLow, false)

      if (this.usevibrate) this.startVibrationListener()
      if (this.usebrightness) this.startBrightnessListener()
      if (this.keepscreenon) cordova.plugins.brightness.setKeepScreenOn(true)
    }
  },

  mounted () {
    setTimeout(() => {
      // Adaptation taille header
      let el = document.getElementsByClassName('v-toolbar__content')
      if (el && el.length > 0) {
        let height = el[0].offsetTop
        el = document.getElementById('toolbar')
        if (el) {
          height += parseInt(el.style.height)
            el.style.height = height + 'px'
        }
      }

      // Maj type connexion
      this.onConnectionChange()
    }, 500)
  },

  beforeDestroy () {
    if (!IS_DESKTOP) {
      window.removeEventListener('online', this.onConnectionChange, false)
      window.removeEventListener('offline', this.onConnectionChange, false)

      window.removeEventListener('batterystatus', this.onBatteryStatus, false)
      window.removeEventListener('batterylow', this.onBatteryLow, false)

      if (this.usevibrate) this.stopVibrationListener()
      if (this.usebrightness) this.stopBrightnessListener()
    }

    if (this.paxTimeout !== null) {
      clearTimeout(this.paxTimeout)
    }
  },

  methods: {
    onConnectionChange () {
      this.networkType = navigator.connection.type
    },
    onBatteryStatus (status) {
      this.isPlugged = status.isPlugged
      this.batteryLevel = Math.round(status.level)
    },
    onBatteryLow (status) {
      alert(this.$i18n.t('info.battery_low', { percent: this.batteryLevel }))
    },
    displayPercent () {
      if (this.useBattery) {
        this.showPercent = true
        setTimeout(() => {
          this.showPercent = false
        }, 5000)
      }
      if (this.totalTransactions > 0) {
        this.showTransactions = true
        setTimeout(() => {
          this.showTransactions = false
        }, 5000)
      }
    },
    sendTransactions () {
      setTimeout(() => {
        this.showTransactions = false
        $getNumberOfTransactions()
      }, 200)
    },
    // VIBRATION
    startVibrationListener () {
      window.addEventListener('click', this.onClick)
    },
    stopVibrationListener () {
      window.removeEventListener('click', this.onClick)
    },
    onClick (event) {
      if (event.target.classList.contains('btn')) {
        navigator.vibrate(80)
      }
    },
    // DRAWER / BAR
    setDrawer () {
      this.$store.commit('drawer', true)
    },
    statusBarPressed () {
      if (this.$route.name === 'index' || this.$route.name === 'settings') {
        this.showEnv = true
      }
    },
    // BRIGHTNESS
    startBrightnessListener () {
      if (cordova.plugins.brightness) {
        // Reduction de la limunosité (avec timeout)
        let time = localStorage.getItem('duration')
        if (time !== null) {
          this.$store.commit('duration', parseInt(time))
        }
        // Trigger click app
        document.addEventListener('touchstart', this.setBrightnessNormal)
        this.setBrightnessLow()
      }
    },
    stopBrightnessListener () {
      if (cordova.plugins.brightness) {
        clearTimeout(this.brightnessTimeout)
        if (this.brightnessLow) {
          cordova.plugins.brightness.setBrightness(-1, () => { this.brightnessLow = false }, () => {})
        }
        document.removeEventListener('touchstart', this.setBrightnessNormal)
      }
    },
    setBrightnessLow () {
      clearTimeout(this.brightnessTimeout)
      this.brightnessTimeout = setTimeout(() => {
        cordova.plugins.brightness.setBrightness(0, () => { this.brightnessLow = true }, () => {})
      }, (this.duration * 1000))
    },
    setBrightnessNormal () {
      if (this.brightnessLow) {
        cordova.plugins.brightness.setBrightness(-1, () => { this.brightnessLow = false }, () => {})
      }
      this.setBrightnessLow()
    },
    //
    showUserName () {
      this.userName = this.$store.state.userName ?? this.cashierName
      setTimeout(() => {
        this.userName = null
      }, 3000)
    },
    changeEnv (env) {
      if (env === 0) {
        document.getElementById('inspire').classList.remove('toolbar-extended')
      } else {
        document.getElementById('inspire').classList.add('toolbar-extended')
      }
      this.currentEnv = env
    }
  }
}
</script>
<style scoped>
.cashier-name {
  display: block;
  font-size: 0.8em;
  opacity: 0.7;
  line-height: 1em;
  position: absolute;
  bottom: 0;
}
</style>

